export const MAP_FILTERS = {
    POI_FILTER_INSERT: 'POI_FILTER_INSERT',
    LEVEL_FILTER_INSERT: "LEVEL_FILTER_INSERT",
    MAP_STYLE_INSERT: "MAP_STYLE_INSERT",
    OPEN_SETTING_DRAWER: "OPEN_SETTING_DRAWER"
}